import { Dialog, DialogPage } from "@sellar-io/components";
import { CreatePackageRulePage } from "./pages/CreatePackageRulePage";
import { useState } from "react";
import { UpdateMoqRules } from "./pages/UpdateMoqRules";
import { VolumeDiscountRules } from "./pages/VolumeDiscountRules";
import { CaseSizeRuleCreateRequestType } from "@sellar-io/api-v2/types";
import { CaseSizeRuleCreateDialogPage } from "./CaseSizeRuleCreateDialogPage";

export const CaseSizeRuleCreateDialog = ({
  active,
  onDismiss,
}: {
  active: boolean;
  onDismiss: () => void;
}) => {
  const [caseSizeRule, setCaseSizeRule] = useState<
    CaseSizeRuleCreateRequestType | undefined
  >();
  const [previousActive, setPreviousActive] = useState(active);

  if (active !== previousActive) {
    setPreviousActive(active);
    if (active) {
      setCaseSizeRule(undefined);
    }
  }

  return (
    <Dialog
      active={active}
      onDismiss={onDismiss}
      initPage={CaseSizeRuleCreateDialogPage.CREATE_PACKAGE_RULE}
    >
      <DialogPage page={CaseSizeRuleCreateDialogPage.CREATE_PACKAGE_RULE}>
        <CreatePackageRulePage
          caseSizeRule={caseSizeRule}
          setCaseSizeRule={setCaseSizeRule}
        />
      </DialogPage>

      {!!caseSizeRule && (
        <>
          <DialogPage page={CaseSizeRuleCreateDialogPage.UPDATE_MOQ_RULES}>
            <UpdateMoqRules caseSizeRule={caseSizeRule} />
          </DialogPage>

          <DialogPage page={CaseSizeRuleCreateDialogPage.VOLUME_DISCOUNT_RULES}>
            <VolumeDiscountRules caseSizeRule={caseSizeRule} />
          </DialogPage>
        </>
      )}
    </Dialog>
  );
};
